<template>
  <div>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <h3>{{ loader_message }}</h3>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Transfer Holds</h1>
        </div>
      </div>

      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <a
            href="javascript:void(0)"
            class="nav-link"
            :class="{ active: activeTab === 'holds' }"
            @click="activeTab = 'holds'"
            >Holds</a
          >
        </li>
        <li class="nav-item" v-if="permissions.includes('manage-recipient-controls')">
          <a
            href="javascript:void(0)"
            class="nav-link"
            :class="{ active: activeTab === 'recipients' }"
            @click="activeTab = 'recipients'"
            >Recipient Controls</a
          >
        </li>
        <li class="nav-item" v-if="permissions.includes('view-recipient-hub')">
          <a
            href="javascript:void(0)"
            class="nav-link"
            :class="{ active: activeTab === 'hub' }"
            @click="activeTab = 'hub'"
            >Hub Lookup</a
          >
        </li>
      </ul>

      <div v-if="activeTab === 'holds'">
        <div class="row align-items-end mb-3">
          <div class="col-xl-2 col-lg-4 col-12">
            <div class="form-group">
              <label>Status</label>
              <select class="form-control" v-model="status">
                <option value="active,temporarily_released">Open</option>
                <option value="active">Active</option>
                <option value="temporarily_released">Temporarily Released</option>
                <option value="cleared">Cleared</option>
                <option value="">All</option>
              </select>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-12">
            <div class="form-group">
              <label>Reason</label>
              <select class="form-control" v-model="reason">
                <option value="">All reasons</option>
                <option value="large_inflow_new_account">Large inflow on new account</option>
                <option value="rapid_pass_through">Rapid pass-through</option>
                <option value="round_trip">Round-trip transfer</option>
                <option value="burst_outflow_young_account">Burst outflow on young account</option>
                <option value="shared_recipient_hub">Shared recipient hub</option>
                <option value="irregular_inflow">Irregular inflows</option>
              </select>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-12">
            <div class="form-group">
              <label>Search</label>
              <input
                type="text"
                class="form-control"
                v-model="search"
                placeholder="Name, email, account"
              />
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-12">
            <div class="form-group">
              <label>Start Date</label>
              <input type="date" class="form-control" v-model="start_date" />
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-12">
            <div class="form-group">
              <label>Stop Date</label>
              <input type="date" class="form-control" v-model="stop_date" />
            </div>
          </div>
          <div class="col-auto">
            <button class="button btn mb-3" @click.prevent="getHolds(1)">Submit</button>
          </div>
        </div>

        <div class="card card--no-shadow">
          <div class="card-body">
            <div
              class="d-flex align-items-center mb-3"
              v-if="selectedHoldIds.length"
            >
              <span class="mr-2">{{ selectedHoldIds.length }} selected</span>
              <button
                v-if="permissions.includes('release-transfer-hold')"
                class="button btn-sm mr-1"
                @click.prevent="promptBulkRelease"
              >
                Bulk Release
              </button>
              <button
                v-if="permissions.includes('clear-transfer-hold')"
                class="button btn-sm"
                @click.prevent="promptBulkClear"
              >
                Bulk Clear
              </button>
            </div>
            <CDataTable :items="holds" :fields="holdFields" pagination sorter>
              <template #select-header>
                <div>
                  <input
                    type="checkbox"
                    :checked="allSelectableSelected"
                    @click.stop
                    @change="toggleSelectAll($event.target.checked)"
                  />
                </div>
              </template>
              <template #select="{item}">
                <td>
                  <input
                    v-if="item.status !== 'cleared'"
                    type="checkbox"
                    :checked="selectedHoldIds.includes(item.id)"
                    @change="toggleHoldSelection(item.id, $event.target.checked)"
                  />
                </td>
              </template>
              <template #customer="{item}">
                <td>
                  <router-link
                    v-if="item.user"
                    :to="{ name: 'CustomerComponent', params: { slug: item.user.id } }"
                  >
                    {{ item.user.first_name }} {{ item.user.last_name }}
                  </router-link>
                  <div class="small text-muted" v-if="item.user">{{ item.user.email }}</div>
                </td>
              </template>
              <template #reason="{item}">
                <td>
                  {{ item.reason_label || item.reason }}
                  <div class="small text-muted" v-if="item.reference_key">
                    Ref: {{ item.reference_key }}
                  </div>
                </td>
              </template>
              <template #status="{item}">
                <td>
                  <span
                    class="badge"
                    :class="{
                      'badge-danger': item.status === 'active',
                      'badge-warning': item.status === 'temporarily_released',
                      'badge-success': item.status === 'cleared'
                    }"
                  >
                    {{ item.status }}
                  </span>
                </td>
              </template>
              <template #amount="{item}">
                <td>{{ formatAmount(item.amount) }}</td>
              </template>
              <template #attempts="{item}">
                <td>{{ item.blocked_attempts || 0 }}</td>
              </template>
              <template #action="{item}">
                <td>
                  <button
                    v-if="permissions.includes('release-transfer-hold') && item.status !== 'cleared'"
                    class="button btn-sm mr-1"
                    @click.prevent="promptRelease(item)"
                  >
                    Release
                  </button>
                  <button
                    v-if="permissions.includes('clear-transfer-hold') && item.status !== 'cleared'"
                    class="button btn-sm"
                    @click.prevent="promptClear(item)"
                  >
                    Clear
                  </button>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'recipients' && permissions.includes('manage-recipient-controls')">
        <div class="row mb-3">
          <div class="col-md-3">
            <input class="form-control" v-model="controlForm.account_number" placeholder="Account number" />
          </div>
          <div class="col-md-2">
            <select class="form-control" v-model="controlForm.list_type">
              <option value="blacklist">Blacklist</option>
              <option value="whitelist">Whitelist</option>
            </select>
          </div>
          <div class="col-md-3">
            <input class="form-control" v-model="controlForm.account_name" placeholder="Account name" />
          </div>
          <div class="col-md-3">
            <input class="form-control" v-model="controlForm.reason" placeholder="Reason" />
          </div>
          <div class="col-md-1">
            <button class="button btn" @click.prevent="promptSaveControl">Add</button>
          </div>
        </div>
        <div class="card card--no-shadow">
          <div class="card-body">
            <CDataTable :items="controls" :fields="controlFields">
              <template #action="{item}">
                <td>
                  <button class="button btn-sm" @click.prevent="promptRemoveControl(item)">
                    Remove
                  </button>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="control_next_page"
              :pages="control_total"
              :onActivePageChange="onControlPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'hub' && permissions.includes('view-recipient-hub')">
        <div class="row mb-3">
          <div class="col-md-4">
            <input
              class="form-control"
              v-model="hubAccount"
              placeholder="Recipient account number"
            />
          </div>
          <div class="col-md-2">
            <button class="button btn" @click.prevent="lookupHub">Lookup</button>
          </div>
        </div>
        <div class="card card--no-shadow" v-if="hubResult">
          <div class="card-body">
            <p>
              <strong>Senders:</strong> {{ hubResult.sender_count }} /
              threshold {{ hubResult.threshold }} ({{ hubResult.window_days }} days)
            </p>
            <p>
              Blacklisted: {{ hubResult.is_blacklisted ? "Yes" : "No" }} ·
              Whitelisted: {{ hubResult.is_whitelisted ? "Yes" : "No" }}
            </p>
            <CDataTable :items="hubResult.senders || []" :fields="hubFields">
              <template #name="{item}">
                <td>
                  <router-link :to="{ name: 'CustomerComponent', params: { slug: item.id } }">
                    {{ item.first_name }} {{ item.last_name }}
                  </router-link>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>

    <two-factor-prompt
      :visible="showTwoFaPrompt"
      :loading="twoFaLoading"
      :description="twoFaDescription"
      :submit-label="twoFaSubmitLabel"
      @close="closeTwoFaPrompt"
      @submit="handleTwoFaSubmit"
    />
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import CDataTable from "@/components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";

const holdFields = [
  "select",
  "customer",
  "account_number",
  "reason",
  "amount",
  "attempts",
  "status",
  "released_until",
  "created_at",
  "action"
];

const controlFields = [
  "account_number",
  "list_type",
  "account_name",
  "reason",
  "date",
  "action"
];

const hubFields = ["name", "email", "account_number"];

export default {
  name: "TransferHolds",
  components: {
    CDataTable,
    CPagination
  },
  data() {
    return {
      pageLoading: false,
      loader_message: "Loading transfer holds...",
      activeTab: "holds",
      holds: [],
      holdFields,
      controlFields,
      hubFields,
      status: "active,temporarily_released",
      reason: "",
      search: "",
      start_date: "",
      stop_date: "",
      next_page: 1,
      current: 1,
      total: 1,
      controls: [],
      control_next_page: 1,
      control_current: 1,
      control_total: 1,
      controlForm: {
        account_number: "",
        list_type: "blacklist",
        account_name: "",
        reason: ""
      },
      hubAccount: "",
      hubResult: null,
      showTwoFaPrompt: false,
      twoFaLoading: false,
      twoFaAction: null,
      pendingHold: null,
      pendingHours: 1,
      pendingClearReason: "",
      pendingControl: null,
      selectedHoldIds: []
    };
  },
  computed: {
    permissions() {
      return this.$store.getters.permissions || [];
    },
    selectableHolds() {
      return (this.holds || []).filter(hold => hold.status !== "cleared");
    },
    allSelectableSelected() {
      return (
        this.selectableHolds.length > 0 &&
        this.selectableHolds.every(hold => this.selectedHoldIds.includes(hold.id))
      );
    },
    twoFaDescription() {
      if (this.twoFaAction === "release-transfer-hold") {
        return "Enter your authenticator code to temporarily release this hold.";
      }
      if (this.twoFaAction === "clear-transfer-hold") {
        return "Enter your authenticator code to permanently clear this hold.";
      }
      if (this.twoFaAction === "bulk-release-transfer-holds") {
        return `Enter your authenticator code to temporarily release ${this.selectedHoldIds.length} hold(s).`;
      }
      if (this.twoFaAction === "bulk-clear-transfer-holds") {
        return `Enter your authenticator code to permanently clear ${this.selectedHoldIds.length} hold(s).`;
      }
      if (this.twoFaAction === "save-recipient-control") {
        return "Enter your authenticator code to save this recipient control.";
      }
      if (this.twoFaAction === "remove-recipient-control") {
        return "Enter your authenticator code to remove this recipient control.";
      }
      return "For security, please enter a fresh code from your authenticator app.";
    },
    twoFaSubmitLabel() {
      if (this.twoFaAction === "release-transfer-hold") return "Release Hold";
      if (this.twoFaAction === "clear-transfer-hold") return "Clear Hold";
      if (this.twoFaAction === "bulk-release-transfer-holds") return "Bulk Release";
      if (this.twoFaAction === "bulk-clear-transfer-holds") return "Bulk Clear";
      if (this.twoFaAction === "save-recipient-control") return "Save Control";
      if (this.twoFaAction === "remove-recipient-control") return "Remove Control";
      return "Verify Code";
    }
  },
  mounted() {
    this.getHolds(1);
    if (this.permissions.includes("manage-recipient-controls")) {
      this.getControls(1);
    }
  },
  methods: {
    formatAmount(amount) {
      if (amount === null || amount === undefined || amount === "") {
        return "—";
      }
      return Number(amount).toLocaleString();
    },
    async getHolds(page) {
      this.pageLoading = true;
      this.loader_message = "Loading transfer holds...";
      try {
        const response = await ApiService.get(
          `customer/transfer-holds?page=${page}&status=${this.status}&reason=${this.reason}&search=${this.search}&start_date=${this.start_date}&stop_date=${this.stop_date}`
        );
        this.holds = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.next_page = this.current;
        this.selectedHoldIds = [];
      } catch (error) {
        ErrorService.onError(error);
      } finally {
        this.pageLoading = false;
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        this.getHolds(this.next_page);
      }
    },
    async getControls(page) {
      try {
        const response = await ApiService.get(`customer/recipient-controls?page=${page}`);
        this.controls = response.data.data.data;
        this.control_current = response.data.data.current_page;
        this.control_total = response.data.data.last_page;
        this.control_next_page = this.control_current;
      } catch (error) {
        ErrorService.onError(error);
      }
    },
    onControlPageChange() {
      if (this.control_current != this.control_next_page) {
        this.getControls(this.control_next_page);
      }
    },
    promptRelease(item) {
      Swal.fire({
        title: "Release transfer hold",
        input: "number",
        inputLabel: "Hours (1-72)",
        inputValue: 1,
        inputAttributes: { min: 1, max: 72 },
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          const hours = parseInt(result.value, 10);
          if (!hours || hours < 1 || hours > 72) {
            Swal.fire("Invalid hours", "Enter a value between 1 and 72", "error");
            return;
          }
          this.pendingHold = item;
          this.pendingHours = hours;
          this.twoFaAction = "release-transfer-hold";
          this.showTwoFaPrompt = true;
        }
      });
    },
    promptClear(item) {
      Swal.fire({
        title: "Clear hold permanently",
        input: "text",
        inputLabel: "Reason",
        inputPlaceholder: "Why is this hold being cleared?",
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          if (!result.value) {
            Swal.fire("Reason required", "", "error");
            return;
          }
          this.pendingHold = item;
          this.pendingClearReason = result.value;
          this.twoFaAction = "clear-transfer-hold";
          this.showTwoFaPrompt = true;
        }
      });
    },
    toggleHoldSelection(id, checked) {
      if (checked) {
        if (!this.selectedHoldIds.includes(id)) {
          this.selectedHoldIds = this.selectedHoldIds.concat(id);
        }
        return;
      }
      this.selectedHoldIds = this.selectedHoldIds.filter(holdId => holdId !== id);
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.selectedHoldIds = this.selectableHolds.map(hold => hold.id);
        return;
      }
      this.selectedHoldIds = [];
    },
    promptBulkRelease() {
      if (!this.selectedHoldIds.length) {
        return;
      }
      Swal.fire({
        title: `Release ${this.selectedHoldIds.length} hold(s)`,
        input: "number",
        inputLabel: "Hours (1-72)",
        inputValue: 1,
        inputAttributes: { min: 1, max: 72 },
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          const hours = parseInt(result.value, 10);
          if (!hours || hours < 1 || hours > 72) {
            Swal.fire("Invalid hours", "Enter a value between 1 and 72", "error");
            return;
          }
          this.pendingHours = hours;
          this.twoFaAction = "bulk-release-transfer-holds";
          this.showTwoFaPrompt = true;
        }
      });
    },
    promptBulkClear() {
      if (!this.selectedHoldIds.length) {
        return;
      }
      Swal.fire({
        title: `Clear ${this.selectedHoldIds.length} hold(s) permanently`,
        input: "text",
        inputLabel: "Reason",
        inputPlaceholder: "Why are these holds being cleared?",
        showCancelButton: true,
        confirmButtonText: "Continue"
      }).then(result => {
        if (result.isConfirmed) {
          if (!result.value) {
            Swal.fire("Reason required", "", "error");
            return;
          }
          this.pendingClearReason = result.value;
          this.twoFaAction = "bulk-clear-transfer-holds";
          this.showTwoFaPrompt = true;
        }
      });
    },
    promptSaveControl() {
      if (!this.controlForm.account_number) {
        Swal.fire("Account number is required", "", "error");
        return;
      }
      this.twoFaAction = "save-recipient-control";
      this.showTwoFaPrompt = true;
    },
    promptRemoveControl(item) {
      this.pendingControl = item;
      this.twoFaAction = "remove-recipient-control";
      this.showTwoFaPrompt = true;
    },
    closeTwoFaPrompt(force = false) {
      if (this.twoFaLoading && !force) {
        return;
      }
      this.twoFaLoading = false;
      this.showTwoFaPrompt = false;
      this.twoFaAction = null;
    },
    handleTwoFaSubmit(code) {
      if (this.twoFaAction === "release-transfer-hold") {
        this.confirmRelease(code);
      } else if (this.twoFaAction === "clear-transfer-hold") {
        this.confirmClear(code);
      } else if (this.twoFaAction === "bulk-release-transfer-holds") {
        this.confirmBulkRelease(code);
      } else if (this.twoFaAction === "bulk-clear-transfer-holds") {
        this.confirmBulkClear(code);
      } else if (this.twoFaAction === "save-recipient-control") {
        this.confirmSaveControl(code);
      } else if (this.twoFaAction === "remove-recipient-control") {
        this.confirmRemoveControl(code);
      }
    },
    async confirmRelease(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post(
          `customer/release-transfer-hold/${this.pendingHold.id}`,
          { hours: this.pendingHours, code }
        );
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.getHolds(this.current);
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async confirmClear(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post(
          `customer/clear-transfer-hold/${this.pendingHold.id}`,
          { reason: this.pendingClearReason, code }
        );
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.getHolds(this.current);
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async confirmBulkRelease(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post("customer/bulk-release-transfer-holds", {
          hold_ids: this.selectedHoldIds,
          hours: this.pendingHours,
          code
        });
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.getHolds(this.current);
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async confirmBulkClear(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post("customer/bulk-clear-transfer-holds", {
          hold_ids: this.selectedHoldIds,
          reason: this.pendingClearReason,
          code
        });
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.getHolds(this.current);
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async confirmSaveControl(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post("customer/recipient-controls", {
          ...this.controlForm,
          code
        });
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.controlForm = {
          account_number: "",
          list_type: "blacklist",
          account_name: "",
          reason: ""
        };
        this.getControls(1);
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async confirmRemoveControl(code) {
      this.twoFaLoading = true;
      try {
        const response = await ApiService.post(
          `customer/remove-recipient-control/${this.pendingControl.id}`,
          { code }
        );
        Swal.fire("Success", response.data.message, "success");
        this.closeTwoFaPrompt(true);
        this.getControls(this.control_current);
      } catch (error) {
        this.twoFaLoading = false;
        ErrorService.onError(error);
      }
    },
    async lookupHub() {
      if (!this.hubAccount) {
        Swal.fire("Enter an account number", "", "error");
        return;
      }
      try {
        const response = await ApiService.get(
          `customer/recipient-hub-check?account_number=${this.hubAccount}`
        );
        this.hubResult = response.data.data;
      } catch (error) {
        ErrorService.onError(error);
      }
    }
  }
};
</script>
